import { useState, useRef, Suspense, useEffect } from "react";
import { useQuery } from "react-query";
import HotelCardSkeleton from "../components/Skeletons/HotelCardsSkeleton";
import HotelSliderSkeleton from "../components/Skeletons/HotelSliderSkeleton";
import useOnScreen from "../hooks/useOnScreen";
import * as apiClient from '../api-client';
import LinkButton from "../components/Common/LinkButton";
import React from "react";

const LazyVacationTypes = React.lazy(() => import('../components/Home/VacationTypes'));
const LatestDestinationsSlider = React.lazy(() => import('../components/LatestDestinationsSlider'));
const LatestDestinationsList = React.lazy(() => import('../components/HotelCard/LatestDestinationsList'));
const AllInclusiveHotelsList = React.lazy(() => import('../components/HotelCard/AllInclusiveHotelsList'));
const BeachHotelsList = React.lazy(() => import('../components/HotelCard/BeachHotelsList'));
const CoupleHotelsList = React.lazy(() => import('../components/HotelCard/CoupleHotelsList'));
const FamilyHotelsList = React.lazy(() => import('../components/HotelCard/FamilyHotelsList'));
const HoneyMoonHotelsList = React.lazy(() => import('../components/HotelCard/HoneymoonHotelsList'));
const LastMinuteHotelsList = React.lazy(() => import('../components/HotelCard/LastMinuteHotelsList'));
const LuxuryHotelList = React.lazy(() => import('../components/HotelCard/LuxuryHotelsList'));
const AllInclusiveSlider = React.lazy(() => import('../components/Sliders/AllInclusiveSlider'));
const BeachSlider = React.lazy(() => import('../components/Sliders/BeachSlider'));
const CoupleSlider = React.lazy(() => import('../components/Sliders/CoupleSlider'));
const FamilySlider = React.lazy(() => import('../components/Sliders/FamilySlider'));
const HoneymoonSlider = React.lazy(() => import('../components/Sliders/HoneymoonSlider'));
const LastMinuteSlider = React.lazy(() => import('../components/Sliders/LastMinuteSlider'));
const LuxurySlider = React.lazy(() => import('../components/Sliders/LuxurySlider'));

export const Resort = () => {
    const [startFetching, setStartFetching] = useState(false);

    useEffect(() => {
        setStartFetching(true);
    }, []);

    const { data: hotels, error, isFetching } = useQuery('fetchHotels', apiClient.fetchHotels, {
        enabled: startFetching
      });
    
    
      const [isExpandedLatest, setIsExpandedLatest] = useState(false);
      const toggleTextLatest = () => setIsExpandedLatest(!isExpandedLatest);
    
      const [isExpandedInclusive, setIsExpandedInclusive] = useState(false);
      const toggleTextInclusive = () => setIsExpandedInclusive(!isExpandedInclusive);
    
      const [isExpandedFamily, setIsExpandedFamily] = useState(false);
      const toggleTextFamily = () => setIsExpandedFamily(!isExpandedFamily);
    
      const [isExpandedCouple, setIsExpandedCouple] = useState(false);
      const toggleTextCouple = () => setIsExpandedCouple(!isExpandedCouple);
    
      const [isExpandedLuxury, setIsExpandedLuxury] = useState(false);
      const toggleTextLuxury = () => setIsExpandedLuxury(!isExpandedLuxury);
    
      const [isExpandedHoneymoon, setIsExpandedHoneymoon] = useState(false);
      const toggleTextHoneymoon = () => setIsExpandedHoneymoon(!isExpandedHoneymoon);
    
      const [isExpandedBeach, setIsExpandedBeach] = useState(false);
      const toggleTextBeach = () => setIsExpandedBeach(!isExpandedBeach);
    
      const [isExpandedLastMinute, setIsExpandedLastMinute] = useState(false);
      const toggleTextLastMinute = () => setIsExpandedLastMinute(!isExpandedLastMinute);    
    
      // useEffect(() => {
      //   window.scrollTo(0, 0);
      // }, []);
    
      if (error) return <div>Error loading hotels.</div>;
    
      // Create refs for each section
      const sectionsRefs = {
        latestDestinations: useRef<HTMLDivElement>(null),
        vacationTypes: useRef<HTMLDivElement>(null),
        allInclusive: useRef<HTMLDivElement>(null),
        family: useRef<HTMLDivElement>(null),
        couple: useRef<HTMLDivElement>(null),
        luxury: useRef<HTMLDivElement>(null),
        honeymoon: useRef<HTMLDivElement>(null),
        beach: useRef<HTMLDivElement>(null),
        lastMinute: useRef<HTMLDivElement>(null),
        budgetDeals: useRef<HTMLDivElement>(null),
        blogSlider: useRef<HTMLDivElement>(null),
      };
    
      // Use the custom hook for each section
      const latestDestinationsVisibility = useOnScreen(sectionsRefs.latestDestinations);
      const vacationTypesVisibility = useOnScreen(sectionsRefs.vacationTypes);
      const allInclusiveVisibility = useOnScreen(sectionsRefs.allInclusive);
      const familyVisibility = useOnScreen(sectionsRefs.family);
      const coupleVisibility = useOnScreen(sectionsRefs.couple);
      const luxuryVisibility = useOnScreen(sectionsRefs.luxury);
      const honeymoonVisibility = useOnScreen(sectionsRefs.honeymoon);
      const beachVisibility = useOnScreen(sectionsRefs.beach);
      const lastMinuteVisibility = useOnScreen(sectionsRefs.lastMinute);
      
    return(
        <>
        <section ref={sectionsRefs.latestDestinations} className='mx-4 md:mx-0 my-12'>
          <h1 className="text-3xl font-semibold">Affordable Holidays</h1>
          <div className={`${isExpandedLatest ? '' : 'flex'}`}>
            {/* <p className='text-black'>Explore our latest destinations and find the perfect spot for your next holiday.</p> */}
            <p className={`text-black mb-2 ${isExpandedLatest ? '' : 'line-clamp-1 w-[75%] md:w-[90%]'}`}>
              Escape the ordinary and embark on an unforgettable adventure with Halo Holidays, your gateway to incredible travel experiences at budget-friendly prices. We understand that wanderlust doesn't have to break the bank, which is why we've curated a diverse range of affordable holidays that cater to every taste and budget. Whether you're dreaming of sun-soaked beaches, vibrant cityscapes, or thrilling mountain adventures, we've got you covered.
              <br />
              Our handpicked selection of destinations spans the globe, from the idyllic shores of the Maldives and Thailand to the cultural richness of Europe and the exotic allure of South America. We offer a variety of travel styles, including all-inclusive resorts, family holidays, couples' retreats, and even <a href='https://www.haloholidays.co.uk/last-minute-deals' className='text-halo-pink hover:text-pink-800'>last-minute deals</a> for those seeking a spontaneous escape. With our competitive prices and expert travel advisors, you can rest assured that you're getting the best value for your money.
              <br />
              Imagine yourself exploring ancient ruins, diving into crystal-clear waters, or indulging in local delicacies, all without straining your wallet. Our cheap holidays are designed to offer you an unforgettable experience without compromising on quality or comfort. We believe that everyone deserves a chance to explore the world, regardless of their budget, and we're committed to making travel accessible to all.
            </p>
            <button
              onClick={toggleTextLatest}
              className={`mb-2 right-0 text-sm text-blue-500 hover:text-blue-700 bg-transparent border-none cursor-pointer ${isExpandedLatest? '' : 'ml-2'}`}
            >
              {isExpandedLatest ? 'Read Less' : 'Read More'}
            </button>
          </div>
          {latestDestinationsVisibility.hasBeenVisible && (
            <>
              <div className="hidden md:block lg:block lgx2:block">
                <Suspense fallback={<HotelCardSkeleton />}>
                  <LatestDestinationsList hotels={hotels ?? []} />
                </Suspense>
              </div>
              <div className="md:hidden lg:hidden lgx2:hidden">
                <Suspense fallback={<HotelSliderSkeleton />}>
                  <LatestDestinationsSlider hotels={hotels ?? []} />
                </Suspense>
              </div>
            </>
          )}
        </section>
        {isFetching && <HotelSliderSkeleton />}

        <section ref={sectionsRefs.vacationTypes} className="p-4 md:p-0 my-8">
          <h2 className="text-3xl font-semibold">Holiday Types</h2>
          <p className='text-black'>Choose from a variety of holiday types that cater to different tastes and preferences.</p>
          {vacationTypesVisibility.hasBeenVisible && (
            <Suspense fallback={'Loading'}>
              <LazyVacationTypes />
            </Suspense>
          )}
        </section>

        <section ref={sectionsRefs.allInclusive} className="mx-4 md:mx-0 my-8">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-semibold">All-Inclusive Holidays</h2>
              {/* <p className='text-black'>Enjoy a hassle-free holiday with our <a className="font-semibold text-black font-underline" href="" title='All inclusive holidays'>all-inclusive</a> packages that cover everything from accommodation to activities.</p> */}
            </div>
            <div className='hidden md:block lg:block lgx2:block'>
              <LinkButton to='/all-inclusive-holidays' btnDescription='View All Deals' />
            </div>
          </div>
          <div className={`${isExpandedInclusive ? '' : 'flex'}`}>
            <p className={`text-black md:mb-2 ${isExpandedInclusive ? '' : 'line-clamp-1 w-[75%] md:w-[90%]'}`}>
              Unwind and experience complete relaxation with our <a href='https://www.haloholidays.co.uk/all-inclusive-holidays' className='text-halo-pink hover:text-pink-800'>all-inclusive holidays</a>. Enjoy hassle-free holidays with flights, accommodation, meals, drinks, and activities all included in one convenient package. Whether you crave adventure, relaxation, or family fun, our all-inclusive resorts offer something for everyone. Savor delicious meals and refreshing drinks, indulge in exciting activities, and soak up the sun on pristine beaches, all without worrying about hidden costs. Discover amazing all-inclusive holiday deals for top destinations like the Maldives, Caribbean, Mexico, and more. Book your dream getaway today and let us take care of the rest!
            </p>
            <button
              onClick={toggleTextInclusive}
              className={`md:mb-2 right-0 text-sm text-blue-500 hover:text-blue-700 bg-transparent border-none cursor-pointer ${isExpandedInclusive? '' : 'ml-2'}`}
            >
              {isExpandedInclusive ? 'Read Less' : 'Read More'}
            </button>
          </div>
          {allInclusiveVisibility.hasBeenVisible && (
            <>
              <div className="hidden md:block lg:block lgx2:block">
                <Suspense fallback={<HotelCardSkeleton />}>
                  <AllInclusiveHotelsList hotels={hotels ?? []} />
                </Suspense>
              </div>
              <div className="container md:hidden lg:hidden">
                <Suspense fallback={<HotelSliderSkeleton />}>
                  <AllInclusiveSlider hotels={hotels ?? []} />
                </Suspense>
              </div>
            </>
          )}
        </section>

        <section ref={sectionsRefs.family} className="mx-4 md:mx-0 my-8">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-semibold">Family Holidays</h2>
            </div>
            <div className='hidden md:block lg:block lgx2:block'>
              <LinkButton to='/family-holidays' btnDescription='View All Deals' />
            </div>
          </div>
          <div className={`${isExpandedFamily ? '' : 'flex'}`}>
            {/* <p className='text-black'>Enjoy a hassle-free holiday with our <a className="font-semibold text-black font-underline" href="" title='All inclusive holidays'>all-inclusive</a> packages that cover everything from accommodation to activities.</p> */}
            <p className={`text-black md:mb-2 ${isExpandedFamily ? '' : 'line-clamp-1 w-[75%] md:w-[90%]'}`}>
              Create unforgettable memories with your loved ones on a family holidays that caters to every age and interest. From thrilling theme parks and water adventures to educational wildlife encounters and cultural experiences, the world is your playground. Choose from all-inclusive family resorts with kids' clubs, splash pads, and endless entertainment options, or embark on a guided tour that takes you on a journey through history, nature, and local traditions. No matter what your family's interests, there's a perfect destination waiting to be discovered.
            </p>
            <button
              onClick={toggleTextFamily}
              className={`md:mb-2 right-0 text-sm text-blue-500 hover:text-blue-700 bg-transparent border-none cursor-pointer ${isExpandedFamily? '' : 'ml-2'}`}
            >
              {isExpandedFamily ? 'Read Less' : 'Read More'}
            </button>
          </div>
            
          {familyVisibility.hasBeenVisible && (
            <>
              <div className="hidden md:block lg:block lgx2:block">
                <Suspense fallback={<HotelCardSkeleton />}>
                  <FamilyHotelsList hotels={hotels ?? []} />
                </Suspense>
              </div>
              <div className="container md:hidden lg:hidden">
                <Suspense fallback={<HotelSliderSkeleton />}>
                  <FamilySlider hotels={hotels ?? []} />
                </Suspense>
              </div>
            </>
          )}
        </section>

        <section ref={sectionsRefs.couple} className="mx-4 md:mx-0 my-8">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-semibold">Couple Holidays</h2>
              {/* <p className='text-black'>Enjoy a romantic escape with our carefully curated couple holidays, perfect for honeymooners and couples.</p> */}
            </div>
            <div className='hidden md:block lg:block lgx2:block'>
              <LinkButton to='/couple-holidays' btnDescription='View All Deals' />
            </div>
          </div>
          <div className={`${isExpandedCouple ? '' : 'flex'}`}>
            <p className={`text-black md:mb-2 ${isExpandedCouple ? '' : 'line-clamp-1 w-[75%] md:w-[90%]'}`}>
              Ignite the romance and rekindle the spark with a couple's holiday designed to create lasting memories. Whether you're celebrating a honeymoon, an anniversary, or simply want to escape the daily grind, our <a href='https://www.haloholidays.co.uk/couple-holidays' className='text-halo-pink hover:text-pink-800'>romantic getaways</a> offer the perfect blend of relaxation and adventure. Unwind in luxurious resorts with private pools and couples' massages, explore charming cities hand-in-hand, or embark on a thrilling safari adventure. With stunning destinations around the world, you're sure to find the perfect escape to celebrate your love.
            </p>
            <button
              onClick={toggleTextCouple}
              className={`md:mb-2 right-0 text-sm text-blue-500 hover:text-blue-700 bg-transparent border-none cursor-pointer ${isExpandedCouple? '' : 'ml-2'}`}
            >
              {isExpandedCouple ? 'Read Less' : 'Read More'}
            </button>
          </div>
          {coupleVisibility.hasBeenVisible && (
            <>
              <div className="hidden md:block lg:block lgx2:block">
                <Suspense fallback={<HotelCardSkeleton />}>
                  <CoupleHotelsList hotels={hotels ?? []} />
                </Suspense>
              </div>
              <div className="container md:hidden lg:hidden">
                <Suspense fallback={<HotelSliderSkeleton />}>
                  <CoupleSlider hotels={hotels ?? []} />
                </Suspense>
              </div>
            </>
          )}
        </section>

        <section ref={sectionsRefs.luxury} className="mx-4 md:mx-0 my-8 mt-16 md:mt-0">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-semibold">Luxury Holidays</h2>
              {/* <p className='text-black'>Indulge in luxury with our exclusive holiday packages that offer the finest amenities and services.</p> */}
            </div>
            <div className='hidden md:block lg:block lgx2:block'>
              <LinkButton to='/luxury-holidays' btnDescription='View All Deals' />
            </div>
          </div>
          <div className={`${isExpandedLuxury ? '' : 'flex'}`}>
            <p className={`text-black md:mb-2 ${isExpandedLuxury ? '' : 'line-clamp-1 w-[75%] md:w-[90%]'}`}>
              Indulge in the finer things in life with a luxurious holiday that caters to your every whim. From private villas with infinity pools to Michelin-starred dining experiences, we offer the ultimate in pampering and exclusivity. Unwind at world-class spas, explore hidden coves on a private yacht, or enjoy bespoke itineraries tailored to your interests. Whether you're seeking a romantic escape, a family adventure, or a solo retreat, our <a href='https://www.haloholidays.co.uk/luxury-holidays' className='text-halo-pink hover:text-pink-800'>luxury holidays</a> will exceed your expectations and leave you feeling refreshed and rejuvenated.
            </p>
            <button
              onClick={toggleTextLuxury}
              className={`md:mb-2 right-0 text-sm text-blue-500 hover:text-blue-700 bg-transparent border-none cursor-pointer ${isExpandedLuxury? '' : 'ml-2'}`}
            >
              {isExpandedLuxury ? 'Read Less' : 'Read More'}
            </button>
          </div>
          {luxuryVisibility.hasBeenVisible && (
            <>
              <div className="hidden md:block lg:block lgx2:block">
                <Suspense fallback={<HotelCardSkeleton />}>
                  <LuxuryHotelList hotels={hotels ?? []} />
                </Suspense>
              </div>
              <div className="container md:hidden lg:hidden">
                <Suspense fallback={<HotelSliderSkeleton />}>
                  <LuxurySlider hotels={hotels ?? []} />
                </Suspense>
              </div>
            </>
          )}
        </section>

        <section ref={sectionsRefs.honeymoon} className="mx-4 md:mx-0 my-8">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-semibold">Honeymoon Holidays</h2>
              {/* <p className='text-black'>Celebrate your love with our romantic honeymoon packages that promise an unforgettable experience.</p> */}
            </div>
            <div className='hidden md:block lg:block lgx2:block'>
              <LinkButton to='/honeymoon-holidays' btnDescription='View All Deals' />
            </div>
          </div>
          <div className={`${isExpandedHoneymoon ? '' : 'flex'}`}>
            <p className={`text-black md:mb-2 ${isExpandedHoneymoon ? '' : 'line-clamp-1 w-[75%] md:w-[90%]'}`}>
              Your honeymoon is a once-in-a-lifetime experience, and we're here to make it truly unforgettable. From romantic overwater bungalows in the Maldives to secluded beachfront villas in Bali, our <a href='https://www.haloholidays.co.uk/honeymoon-holidays' className='text-halo-pink hover:text-pink-800'>honeymoon holidays</a> offer the perfect setting for your love story to unfold. Indulge in intimate dinners, couples' massages, and bespoke experiences designed to create lasting memories. Whether you're dreaming of a relaxing beach escape or an adventurous exploration, we'll help you craft the perfect honeymoon itinerary.
            </p>
            <button
              onClick={toggleTextHoneymoon}
              className={`md:mb-2 right-0 text-sm text-blue-500 hover:text-blue-700 bg-transparent border-none cursor-pointer ${isExpandedHoneymoon? '' : 'ml-2'}`}
            >
              {isExpandedHoneymoon ? 'Read Less' : 'Read More'}
            </button>
          </div>
          {honeymoonVisibility.hasBeenVisible && (
            <>
              <div className="hidden md:block lg:block lgx2:block">
                <Suspense fallback={<HotelCardSkeleton />}>
                  <HoneyMoonHotelsList hotels={hotels ?? []} />
                </Suspense>
              </div>
              <div className="container md:hidden lg:hidden">
                <Suspense fallback={<HotelSliderSkeleton />}>
                  <HoneymoonSlider hotels={hotels ?? []} />
                </Suspense>
              </div>
            </>
          )}
        </section>

        <section ref={sectionsRefs.beach} className="mx-4 md:mx-0 my-8">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-semibold">Beach Holidays</h2>
              {/* <p className='text-black'>Relax and unwind on the sandy shores with our beach holiday packages that offer sun, sea, and sand.</p> */}
            </div>
            <div className='hidden md:block lg:block lgx2:block'>
              <LinkButton to='/beach-holidays' btnDescription='View All Deals' />
            </div>
          </div>
          <div className={`${isExpandedBeach ? '' : 'flex'}`}>
            <p className={`text-black md:mb-2 ${isExpandedBeach ? '' : 'line-clamp-1 w-[75%] md:w-[90%]'}`}>
              Escape to sun-kissed shores and crystal-clear waters with a <a href='https://www.haloholidays.co.uk/beach-holidays' className='text-halo-pink hover:text-pink-800'>beach holiday</a> that will leave you feeling refreshed and revitalized. Whether you're seeking a family-friendly resort with plenty of activities, a romantic retreat for two, or a solo escape to unwind, our beach destinations offer something for everyone. From the iconic shores of Thailand and the Maldives to the pristine beaches of the Caribbean and the Mediterranean, we'll help you find your perfect slice of paradise.
            </p>
            <button
              onClick={toggleTextBeach}
              className={`md:mb-2 right-0 text-sm text-blue-500 hover:text-blue-700 bg-transparent border-none cursor-pointer ${isExpandedBeach? '' : 'ml-2'}`}
            >
              {isExpandedBeach ? 'Read Less' : 'Read More'}
            </button>
          </div>
          {beachVisibility.hasBeenVisible && (
            <>
              <div className="hidden md:block lg:block lgx2:block">
                <Suspense fallback={<HotelCardSkeleton />}>
                  <BeachHotelsList hotels={hotels ?? []} />
                </Suspense>
              </div>
              <div className="container md:hidden lg:hidden">
                <Suspense fallback={<HotelSliderSkeleton />}>
                  <BeachSlider hotels={hotels ?? []} />
                </Suspense>
              </div>
            </>
          )}
        </section>

        <section ref={sectionsRefs.lastMinute} className="mx-4 md:mx-0 my-8">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-semibold">Last Minute Holidays</h2>
              {/* <p className='text-black'>Find amazing last-minute deals on holidays and make spontaneous travel plans with ease.</p> */}
            </div>
            <div className='hidden md:block lg:block lgx2:block'>
              <LinkButton to='/last-minute-holidays' btnDescription='View All Deals' />
            </div>
          </div>
          <div className={`${isExpandedLastMinute ? '' : 'flex'}`}>
            <p className={`text-black md:mb-2 ${isExpandedLastMinute ? '' : 'line-clamp-1 w-[75%] md:w-[90%]'}`}>
              Embrace spontaneity and seize the moment with our incredible <a href='https://www.haloholidays.co.uk/last-minute-holidays' className='text-halo-pink hover:text-pink-800'>last-minute holiday</a> deals. Whether you're looking for a quick weekend getaway or a longer escape, we offer fantastic savings on flights, hotels, and all-inclusive packages. Explore our diverse range of destinations and experiences, from beach resorts to city breaks, and find the perfect last-minute holiday to suit your budget and interests.
            </p>
            <button
              onClick={toggleTextLastMinute}
              className={`md:mb-2 right-0 text-sm text-blue-500 hover:text-blue-700 bg-transparent border-none cursor-pointer ${isExpandedLastMinute? '' : 'ml-2'}`}
            >
              {isExpandedLastMinute ? 'Read Less' : 'Read More'}
            </button>
          </div>
          {lastMinuteVisibility.hasBeenVisible && (
            <>
              <div className="hidden md:block lg:block lgx2:block">
                <Suspense fallback={<HotelCardSkeleton />}>
                  <LastMinuteHotelsList hotels={hotels ?? []} />
                </Suspense>
              </div>
              <div className="container md:hidden lg:hidden">
                <Suspense fallback={<HotelSliderSkeleton />}>
                  <LastMinuteSlider hotels={hotels ?? []} />
                </Suspense>
              </div>
            </>
          )}
        </section>

        </>
    );
};

export default Resort;